import React, { useCallback } from 'react'
import { WrapField, WrapFieldContent, WrapGender } from 'components/Form/Styled'
import { Error } from 'components/Form';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { WrapEditor } from './Styled'

const CustomEditor = (props) => {
    const { gridArea, arrayIndex, disabled, className, input, uploadImage } = props
    const { value, onChange } = input


    // const { mutateAsync: uploadImage } = useMutation({
    //     mutationFn: uploadImageFileFetch
    // })

    const uploadImageCallBack = useCallback(async (file) => {
        const data = await uploadImage?.(file)
        return { data: { link: data.url } } // הנח שהשרת מחזיר את ה-URL של התמונה
    }, [])

    // const uploadImageCallBack = (file) => {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //         setImages?.((prevImages) => [...prevImages, reader.result]);
    //     };
    //     reader.readAsDataURL(file);
    //     return new Promise((resolve) => {
    //         resolve({ data: { link: URL.createObjectURL(file) } });
    //     });
    // };

    return (
        <WrapField className={className} gridArea={`${gridArea}_${arrayIndex}`}>
            <WrapFieldContent>
                <WrapEditor disabled={disabled}>
                    <Editor
                        editorState={value}
                        toolbarClassName="toolbar-editor"
                        wrapperClassName="wrapper-editor"
                        editorClassName="content-editor"
                        onEditorStateChange={onChange}
                        toolbar={{
                            image: {
                                "previewImage": true,
                                uploadCallback: uploadImageCallBack,
                                alt: { present: true, mandatory: false },
                            },
                        }}
                    />
                </WrapEditor>
            </WrapFieldContent>
            <Error {...props} />
        </WrapField>
    )
}

export default CustomEditor